export default "__VITE_ASSET__DHiflHUQ__"